import Driver from 'driver.js';
const filterWorkTaskGif = require('@/assets/welcome/filter_work.gif');
const filterTaskGif = require('@/assets/welcome/filter_kanban.gif');
import { useInstance } from 'common-module/src/util/useInstance';
export type OverseasGuideConfig = {
  key: string;
  triggerFinish?: boolean;
  showDriverStep?: boolean;
  onClose?: () => void;
  onHighLightClick?: (e: MouseEvent) => void;
  steps: {
    selector: string;
    popover: Driver.PopoverOptions;
    routePath?: string;
    wait?: number;
    maxWait?: number;
    showCloseIcon?: boolean;
    highlightClickStop?: boolean;
    beforeStart?: any;
    notFoundTip?: string;
    afterEnd?: () => void;
  } [];
}

//title description notFoundTip 国际化用t()包裹，在index.ts会正则替换
export const OverseasGuideDriverConfig : {[key: string]: OverseasGuideConfig } = {
  'CREATE_PROJECT': {
    key: 'CREATE_PROJECT',
    steps:[
      {
        selector: '.zk-left-menu-item[data-menu="project"] .zk-left-menu-item__content',
        routePath: '',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.create_project4.description)',
          position: 'right'
        }
      },
      {
        selector: '.zk-project-default-layout__main .project-list-create-btn .el-button',
        routePath: '/project/list',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.create_project0.description)',
          position: 'left'
        }
      },
      {
        selector: '.zk-select-template-dialog__template-content .zk-select-template-dialog__card-item',
        routePath: '/project/list',
        wait: 500,
        showCloseIcon: true,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.create_project1.description)',
          position: 'bottom'
        }
      },
      {
        selector: '.zk-template-explain-dialog .el-dialog__footer .el-button--primary',
        routePath: '/project/list',
        wait: 1500,
        showCloseIcon: true,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.create_project2.description)',
          position: 'right-bottom'
        }
      },
      {
        selector: '.zk-project-dialog .el-dialog__footer .el-button--primary',
        routePath: '/project/list',
        wait: 500,
        showCloseIcon: true,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.create_project3.description)',
          position: 'right-bottom'
        }
      }
    ]
  },
  'CREATE_ISSUE': {
    key: 'CREATE_ISSUE',
    steps: [
      {
        selector: '.zk-float-add-btn__wrapper',
        routePath: '/work/list',
        showCloseIcon: true,
        popover: {
          title: 't(overseasGuide.create_issue0.title)',
          description: 't(overseasGuide.create_issue0.description)',
          position: 'top-right'
        }
      }
    ]
  },
  'REFINE_FIELD_LAYOUT': {
    key: 'REFINE_FIELD_LAYOUT',
    triggerFinish: true,
    steps: [
      {
        // eslint-disable-next-line
        selector: '.zk-top-nav__navs .zk-top-nav__nav-name--project-worktype',
        routePath: '/kanban/list',
        showCloseIcon: true,
        popover: {
          title: 't(overseasGuide.refine_field_layout0.title)',
          description: 't(overseasGuide.refine_field_layout0.description)',
          position: 'bottom-right'
        }
      },
      {
        selector: '.zk-project-setting-issue-type-list__row-operate >span:nth-child(2) .el-link--inner',
        routePath: '/project/worktype',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.refine_field_layout0.title)',
          description: 't(overseasGuide.refine_field_layout1.description)',
          position: 'bottom-right'
        }
      }
    ]
  },
  LEARN_ABOUT_DASHBOARD: {
    key: 'LEARN_ABOUT_DASHBOARD',
    triggerFinish: true,
    steps: [
      {
        selector: '.zk-left-menu .zk-left-menu-item[data-menu="dashboard"] .zk-left-menu-item__content',
        routePath: '',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.learn_about_dashboard0.title)',
          description: 't(overseasGuide.learn_about_dashboard0.description)',
          position: 'right'
        }
      },
      {
        selector: '#guide-create-dashboard',
        routePath: '/dashboard',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.learn_about_dashboard0.title)',
          description: 't(overseasGuide.learn_about_dashboard1.description)',
          position: 'bottom-right'
        }
      }
    ]
  },
  INVITE_MEMBERS: {
    key: 'INVITE_MEMBERS',
    steps: [
      {
        selector: '.zk-left-aside__invite',
        routePath: '/kanban/list',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.invite_members0.title)',
          description: 't(overseasGuide.invite_members0.description)',
          position: 'right-bottom'
        }
      }
    ]
  },
  FILTER_IMPORTANT_TASKS_AND_CREATE_SPRINT:{
    key: 'FILTER_IMPORTANT_TASKS',
    triggerFinish: true,
    steps: [
      {
        selector: '.zk-kanban-index .zk-the-kanban-empty__sprint',
        routePath: '/kanban/list',
        showCloseIcon: true,
        wait: 800,
        popover: {
          title: 't(overseasGuide.filter_important_tasks0.title)',
          description: 't(overseasGuide.filter_important_tasks0.description)',
          position: 'bottom'
        }
      },
      {
        selector: '.zk-edit-sprint-dialog__action-save',
        routePath: '/kanban/list',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.filter_important_tasks0.title)',
          description: 't(overseasGuide.filter_important_tasks1.description)',
          position: 'bottom'
        }
      },
      {
        selector: '.zk-kanban-index .zk-common-filter-top-index__main',
        routePath: '/kanban/list',
        showCloseIcon: true,
        wait: 1000,
        popover: {
          title: 't(overseasGuide.filter_important_tasks0.title)',
          description: `<div class="driver-content-filter-task">
            <div>t(overseasGuide.filter_important_tasks2.description)</div>
            <img src="${filterTaskGif}">
          </div>`,
          position: 'bottom'
        }
      }
    ]
  },
  FILTER_IMPORTANT_TASKS: {
    key: 'FILTER_IMPORTANT_TASKS',
    triggerFinish: true,
    steps: [
      {
        selector: '.zk-kanban-index .zk-common-filter-top-index__main',
        routePath: '/kanban/list',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.filter_important_tasks0.title)',
          description: `<div class="driver-content-filter-task">
            <div>t(overseasGuide.filter_important_tasks2.description)</div>
            <img src="${filterTaskGif}">
          </div>`,
          position: 'bottom'
        }
      }
    ]
  },
  WORK_FILTER_IMPORTANT_TASKS: {
    key: 'FILTER_IMPORTANT_TASKS',
    triggerFinish: true,
    steps: [
      {
        // eslint-disable-next-line
        selector: '.zk-air-table .zk-common-filter-top-index__add-filter .iconicon_tianjia',
        routePath: '/work/table',
        showCloseIcon: true,
        wait: 500,
        popover: {
          title: 't(overseasGuide.filter_important_tasks0.title)',
          description: `<div class="driver-content-filter-task">
            <div>t(overseasGuide.filter_important_tasks2.description)</div>
            <img src="${filterWorkTaskGif}">
          </div>`,
          position: 'bottom-right'
        }
      }
    ]
  },
  FINISH_ALL_TASK_GUIDE: {
    key: 'FINISH_ALL_TASK_GUIDE',
    showDriverStep: false,
    steps: [
      {
        selector: '#help_center_close-module-guide',
        routePath: '',
        showCloseIcon: true,
        wait: 350,
        popover: {
          title: 't(overseasGuide.finish_all_task_guide0.title)',
          description: 't(overseasGuide.finish_all_task_guide0.description)',
          position: 'right-bottom'
        }
      }
    ]
  },
  HIGHLIGHT_PROJECT_MENU_GUIDE: {
    key: 'HIGHLIGHT_PROJECT_MENU_GUIDE',
    showDriverStep: false,
    onClose:() => {
      const instance = useInstance();
      instance.$track.send('Guide_CreateProject', { 'position': 'close' }, true);
    },
    onHighLightClick: (e: MouseEvent) => {
      if (!e) {
        return;
      }
      const instance = useInstance();
      const addProjectIconEl = document.querySelector('.zk-left-aside__add-p');
      if (addProjectIconEl && addProjectIconEl.contains(e.target as Element)) {
        instance.$track.send('Guide_CreateProject', { 'position': 'create' }, true);
      } else {
        instance.$track.send('Guide_CreateProject', { 'position': 'project_list' }, true);
      }
    },
    steps: [
      {
        selector: '.zk-left-menu-item[data-menu="project"] .zk-left-menu-item__content',
        routePath: '',
        showCloseIcon: true,
        wait: 200,
        popover: {
          title: 't(overseasGuide.create_project0.title)',
          description: 't(overseasGuide.highlightProjectMenu.desc)',
          position: 'right'
        }
      }
    ]
  },
  CHECK_ROADMAP: {
    triggerFinish: true,
    key: 'CHECK_ROADMAP',
    steps: [
      {
        selector: '.zk-left-aside .zk-left-menu-item[data-menu="roadmap"] >div',
        showCloseIcon: true,
        wait: 0,
        maxWait: 200,
        popover: {
          title: 't(overseasGuide.check_roadmap0.title)',
          description: 't(overseasGuide.check_roadmap0.description)',
          position: 'right-center'
        },
        notFoundTip: 't(overseasGuide.check_roadmap0.notFoundTip)'
      }
    ]
  },
  CHECK_TEAM_VIEW: {
    triggerFinish: true,
    key: 'CHECK_TEAM_VIEW',
    steps: [
      {
        selector: '.zk-left-aside .zk-left-menu-item[data-menu="team"] >div',
        showCloseIcon: true,
        wait: 0,
        maxWait: 200,
        popover: {
          title: 't(overseasGuide.check_team_view0.title)',
          description: 't(overseasGuide.check_team_view0.description)',
          position: 'right-center'
        },
        notFoundTip: 't(overseasGuide.check_team_view0.notFoundTip)'
      }
    ]
  },
  CHECK_VERSION: {
    triggerFinish: true,
    key: 'CHECK_VERSION',
    steps: [
      {
        selector: '.zk-left-aside .zk-left-menu-item[data-menu="release"] >div',
        showCloseIcon: true,
        maxWait: 200,
        wait: 0,
        popover: {
          title: 't(overseasGuide.check_version0.title)',
          description: 't(overseasGuide.check_version0.description)',
          position: 'right-center'
        },
        notFoundTip: 't(overseasGuide.check_version0.notFoundTip)'
      }
    ]
  },
  CHECK_AUTOMATIC: {
    key: 'CHECK_AUTOMATIC',
    triggerFinish: true,
    steps: [
      {
        selector: '.zk-top-nav__actions .top-nav-automation',
        showCloseIcon: true,
        routePath: '/kanban/list',
        wait: 0,
        maxWait: 1000,
        popover: {
          title: 't(overseasGuide.check_automatic0.title)',
          description: 't(overseasGuide.check_automatic0.description)',
          position: 'bottom-center'
        },
        notFoundTip: 't(overseasGuide.check_automatic0.notFoundTip)'
      }
    ]
  },
  MEET_MY_AI_ASSISTANT_RISK: {
    key: 'MEET_MY_AI_ASSISTANT_RISK',
    triggerFinish: false,
    steps: [
      {
        selector: '.zk-robot-chat-button',
        showCloseIcon: true,
        routePath: '/kanban/list',
        wait: 0,
        maxWait: 1000,
        popover: {
          title: 't(overseasGuide.webIm.step1.title)',
          description: 't(overseasGuide.webIm.step1.desc)',
          position: 'top-left'
        }
      }
    ]
  },
  MEET_MY_AI_ASSISTANT_REPORT: {
    key: 'MEET_MY_AI_ASSISTANT_REPORT',
    triggerFinish: false,
    steps: [
      {
        selector: '.zk-robot-chat-button',
        showCloseIcon: true,
        wait: 0,
        maxWait: 1000,
        popover: {
          title: 't(overseasGuide.webIm.step1.title)',
          description: 't(overseasGuide.webIm.step1.desc)',
          position: 'top-left'
        }
      }
    ]
  }
};
